<template>
  <div>
    <!-- <div style="height: 70px;"></div> -->
     
    <div class="header">
      <div class="head">
        <img src="../../assets/images/qie/9.png" class="header_left"/>
        <div class="header_right">
          <div class="header_right_cet" :class="status==index?'head_sty':''" v-for="(item,index) in navlist" @click="jump(item.path)">
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    status:{
      type:[Number,String]
    }
  },
  data() {
    return {
      path:'',
      navlist: [
        {
          title: "首页",
          path: "/",
          checked: false,
        },
        {
          title: "园区简介",
          path: "/brief",
          checked: false,
        },
        {
          title: "公共服务",
          path: "/servicelist",
          checked: false,
        },
        {
          title: "园区企业",
          path: "/enterprise",
          checked: false,
        },
        {
          title: "本地政策",
          path: "/policy",
          checked: false,
        },
        {
          title: "关于我们",
          path: "/about",
          checked: false,
        }
      ],
    };
  },
  watch: { 
	
		},
  methods: {
    jump(path){
        // this.path = path
        this.$router.push({ path: path })
    }
  },
  created() {

  },
};
</script>
<style scoped>
  .header{
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    /* position: fixed;
    top:0; */
    z-index: 99;
  }
  .header_left{
    width: 250px;
    height: 34px;
  }
  .head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 1200px;
    width: 70%;
  }
  .header_right{
    display: flex;
  }
  .header_right_cet{
    font-size: 18px;
    color: #717171;
    margin: 0 33px;
    cursor: pointer;
  }
  .header_right_cet:last-child{
    margin-right: 0;
  }
  .header_right_cet:first-child{
    margin-left: 0;
  }
  .head_sty{
    color: #0170c1;
  }
</style>



// WEBPACK FOOTER //
// header.vue?7c7b9a3c